import React from "react";
import { Mail, Phone, Globe } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#E4EAF7] bg-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <BrandLogo size="md" />
            <p className="mt-3 text-sm text-[#5A6A94] max-w-xs">{t.tagline}</p>
          </div>
          <div>
            <h4 className="font-display font-bold text-[#0B3D91] mb-3 text-sm uppercase tracking-wider">{t.footer.contact}</h4>
            <ul className="space-y-2 text-sm text-[#0F1E3D]">
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#F97316]" />
                <a href="mailto:info@sseuropa.com" className="hover:text-[#0B3D91]" data-testid="footer-email">info@sseuropa.com</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#F97316]" />
                <a href="tel:+393520716656" className="hover:text-[#0B3D91]" data-testid="footer-phone">+39 352 0716656</a>
              </li>
              <li className="flex items-center gap-2">
                <Globe size={14} className="text-[#F97316]" />
                <a href="https://www.sseuropa.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#0B3D91]" data-testid="footer-website">{t.footer.website}</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-[#0B3D91] mb-3 text-sm uppercase tracking-wider">{t.footer.visit}</h4>
            <a href="https://www.sseuropa.com" target="_blank" rel="noopener noreferrer" className="btn-outline !py-2 !px-4 text-sm">
              <Globe size={14} /> {t.footer.website}
            </a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-[#E4EAF7] text-center text-xs text-[#8494B8]">
          {t.footer.rights}
        </div>
      </div>
    </footer>
  );
}
